



















































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

@Component
export default class ApplicationForm extends Vue {
  private desiredConditionIsOpen: boolean = false;

  // TODO: 削除する
  private desiredPrice: number = 80;
  private desiredShift: Array<string> = [
    '平日',
    '休日',
    '2日以下',
    '3日',
    '4日',
    '5日',
    '日勤',
    '夜勤',
    '6時間/日未満',
  ];
  private contact: string =
    'はじめまして。ほにゃららと申します。ほにゃららについて確認させてください。よろしくお願いいたします。';

  private openDesiredCondition() {
    this.desiredConditionIsOpen = !this.desiredConditionIsOpen;
  }
  private unbookmark() {
    return;
  }
}
